import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const IssueRefundErrorModal = ({ show, onClose, error }) => {
  const { t } = useTranslation()

  const renderError = () => {
    if (typeof error === 'object') {
      return JSON.stringify(error, null, 2)
    }
    return error
  }

  return (
    <Modal show={show} size="m" title={t('Error al emitir el reembolso')} onClose={onClose}>
      <Styles.MainContainer>
        <Text type="bodyMRegular">{t('Ha ocurrido un error y no ha sido posible emitir el reembolso.')}</Text>
        <Styles.ErrorContainer>
          <Text type="bodyMonospaced">{renderError()}</Text>
        </Styles.ErrorContainer>
        <Button onClick={onClose}>{t('Entendido')}</Button>
      </Styles.MainContainer>
    </Modal>
  )
}

export default IssueRefundErrorModal
